import { configureStore } from '@reduxjs/toolkit'
import content from './content'

const reducer = {
  content
}

const store = configureStore({ reducer })

export default store
